import { useTranslation } from 'react-i18next';
import { useCallback, useContext } from 'react';
import { RoleTypesEnum } from 'dash-common';
import { Form, FormContext } from 'dash-ui';
import { useGetOrganizationRolesQuery } from 'gql/generated.graphql';

import { FormFields } from 'pages/organizations/OrganizationDetailsPage/components/OrganizationDetailsTabs/components/OrganizationUsers/components/SaveOrganizationUsersModal/constants/constants';
import useValidation from 'pages/organizations/OrganizationDetailsPage/components/OrganizationDetailsTabs/components/OrganizationUsers/components/SaveOrganizationUsersModal/hooks/useValidation';

const RoleSelect = () => {
  const { t } = useTranslation(['forms', 'common', 'pages']);
  const { formErrors, stateHandlers, formState, setFormValues } =
    useContext(FormContext);
  const valid = useValidation();
  const { data, loading } = useGetOrganizationRolesQuery();
  const roles = data?.getOrganizationRoles.collection || [];

  // FIXME: re-check callback
  const handleSelectInputs = useCallback(
    (value: string) => {
      const role = roles.find(({ _id }) => _id === value);
      stateHandlers[FormFields.Role](role);
      valid(FormFields.Role, role?.type || '');

      if (role?.type === RoleTypesEnum.ORG_OWNER) {
        setFormValues({ properties: [] });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [roles]
  );

  return (
    <Form.Group w="100%" mt={3}>
      <Form.Label required>{t('forms:labels:role')}</Form.Label>
      <Form.Select
        menuPosition="fixed"
        isLoading={loading}
        options={roles.map((item) => ({
          value: item._id,
          label: t(`common:roles.${item.type}`),
        }))}
        value={formState?.role?._id}
        placeholder={t('forms:placeholders.role')}
        w="100%"
        onChanged={handleSelectInputs}
        $errorType={formErrors[FormFields.Role]?.type}
      />
      <Form.Feedback $errorType={formErrors[FormFields.Role]?.type}>
        {formErrors[FormFields.Role]?.message}
      </Form.Feedback>
    </Form.Group>
  );
};

export default RoleSelect;
